import type { Revision, RevisionPage } from '../../types';
import { mutations } from '../../utils';

/**
 * Get a page of a revision by its ID. Only the revision's own pages match, so an ID such as
 * `__proto__` resolves to nothing rather than to an inherited object.
 */
export function getPageInRevision(revision: Revision, pageId: string): RevisionPage | undefined;
export function getPageInRevision(
    revision: mutations.MutableData<Revision>,
    pageId: string
): mutations.MutableData<RevisionPage> | undefined;
export function getPageInRevision(
    revision: mutations.MutableData<Revision>,
    pageId: string
): mutations.MutableData<RevisionPage> | undefined {
    return mutations.getIn(revision, ['pages', pageId] as const);
}
